<!--仓库管理 库存-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" class="demo-form-inline" style="padding:0;margin:0" label-suffix="：" size="medium">
          <el-form-item label="产品名称">
            <el-input v-model="searchForm.name" @keyup.enter.native="handleSearch()" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品编码">
            <el-input v-model="searchForm.code" @keyup.enter.native="handleSearch()" clearable></el-input>
          </el-form-item>
          <el-form-item label="分类">
            <el-select v-model="searchForm.CATALOG_ID" clearable>
              <el-option v-for="item in catalogList" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" v-if="WAREHOUSE_MODE == 2">
            <el-select style="width: 100px" v-model="searchForm.lock" @change="handleSearch">
              <el-option v-for="item in productionStatus" :key="item.id" :value="item.id" :label="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="库位" v-if="WAREHOUSE_MODE == 2">
            <el-select style="width: 200px" v-model="searchForm.location" clearable filterable
              :filter-method="positionFilter">
              <el-option v-for="item in positionList" :key="item.ID" :value="item.CODE" :label="item.CODE">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="温区">
            <el-select style="width: 200px" v-model="searchForm.WZ_TYPE_ID" clearable filterable>
              <el-option v-for="item in WZ_list" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch" :loading="loading">筛选</el-button>
            <el-button type="primary" @click="handleSearchNear" :loading="loading">筛选临保</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="exportOrder">导出库存</el-button>
            <el-button type="primary" plain @click="exportRecord">导出库存流水</el-button>
            <el-button type="primary" plain @click="exportWhouse">导出临保</el-button>
            <el-button type="primary" plain @click="exportStockExcl" v-if="WAREHOUSE_MODE == 2">
              导出产品库位表
            </el-button>
            <el-button @click="showBlock" v-if="showStatus === 1">隐藏零库存</el-button>
            <el-button @click="showBlock" v-else>显示零库存</el-button>
            <el-button @click="gotoHistoricalInventory">历史库存</el-button>
            <el-button @click="gotoSafetyStockWarning" type="primary">安全库存预警</el-button>
            <tooltip-button v-if="searchForm.lock == 0 && WAREHOUSE_MODE == 2" :disabled="Boolean(productArray.length)"
              tipContent="请先进行勾选" buttonType="primary" buttonText="批量锁定商品" @click="bathLockProduct">
            </tooltip-button>
            <tooltip-button v-if="searchForm.lock == 1 && WAREHOUSE_MODE == 2" :disabled="Boolean(productArray.length)"
              tipContent="请先进行勾选" buttonType="primary" buttonText="批量解锁商品" @click="bathUnLockProduct">
            </tooltip-button>
            <el-button type="primary" plain @click="导出滞销品()">导出滞销品</el-button>
            <el-button type="primary" plain @click="打开报溢报损模态框()">报溢报损导出</el-button>
            <el-button type="primary" plain @click="批量退货()" v-if="fun_dic[1050201]">批量退货</el-button>
            <!--            <el-button type="primary" plain @click="批量上传批次报告()" v-if="fun_dic[1050202]">批量上传批次报告</el-button>-->
            <el-button type="primary" plain @click="批量上传批次报告()">批量上传批次报告</el-button>
            <!--            <el-button @click="bathLockProduct" v-if="searchForm.lock == 0 && WAREHOUSE_MODE == 2" :disabled="!productArray.length" type="primary">批量锁定商品</el-button>-->
            <!--            <el-button @click="bathUnLockProduct" v-if="searchForm.lock == 1 && WAREHOUSE_MODE == 2" :disabled="!productArray.length" type="primary">批量解锁商品</el-button>-->
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <h5>总金额：{{ this.total_price }}</h5>
      <el-col :span="24">
        <el-tabs type="border-card" @tab-click="getTabValue">
          <el-tab-pane v-for="(item, index) in firstTypeList" :key="index" :label="item.NAME" :code="item.INNER_CODE">
          </el-tab-pane>
          <div class="el-tabs__content">
            <el-table :data="tableData" stripe border style="width: 100%"
              @selection-change="handleProductSelectionChange" @sort-change="date_sort">
              <el-table-column type="selection" width="60" fixed="left"></el-table-column>
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <el-table-column prop="PRODUCT_CODE" label="产品编码" min-width="80"></el-table-column>
              <el-table-column prop="PRODUCT_NAME" label="产品" min-width="80"></el-table-column>
              <el-table-column prop="TYPE_UNIT" label="单位" min-width="70"></el-table-column>
              <el-table-column prop="PRODUCT_PRICE" label="单价" min-width="70"></el-table-column>
              <el-table-column prop="BEFORE_TAX_PRICE" label="不含税单价" min-width="70"></el-table-column>
              <el-table-column prop="TAX_RATE" label="税率" min-width="45"></el-table-column>
              <el-table-column prop="BATCH" label="批次" min-width="70"></el-table-column>
              <el-table-column label="来源单号" min-width="70">
                <template slot-scope="scope">
                  <el-tooltip content="点击查看该批次产品的订单信息">
                    <el-button type="text" @click="showOrderDetail(scope.row)">
                      {{ scope.row.ORDER_ID || '' }}
                    </el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="PRODUCTION_DATE" label="生产日期" min-width="70"></el-table-column>
              <el-table-column label="保质期" min-width="70">
                <template slot-scope="scope">
                  <span>{{ scope.row.QGP + QGP_TIME_TYPE[scope.row.QGP_TIME_TYPE] }}</span>
                </template>
              </el-table-column>
              <el-table-column v-if="near == 1" prop="LINBAO_DATE" label="临保日期" min-width="70"></el-table-column>
              <el-table-column prop="PRODUCT_COUNT" label="库存数量" min-width="45"></el-table-column>
              <el-table-column prop="PRODUCT_WORTH" label="剩余价值" min-width="45"></el-table-column>
              <el-table-column prop="IN_WAREHOUSE_DATE" label="入库日期" sortable="custom" min-width="70"></el-table-column>
              <el-table-column prop="LOCATION_CODE" label="库位" min-width="45" v-if="WAREHOUSE_MODE == 2">
              </el-table-column>
              <el-table-column prop="WZ_NAME" label="温区" min-width="70" v-if="showTemperatureZone"></el-table-column>
              <el-table-column prop="LOCK_REASON" label="锁库原因" min-width="100" v-if="searchForm.lock === 1">
              </el-table-column>
              <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                  <el-tooltip v-if="searchForm.lock === 0 && WAREHOUSE_MODE == 2" class="item" effect="dark"
                    content="锁定商品" placement="top-start">
                    <el-button style="color: #67c23a; padding-top: 0px" type="text" icon="el-icon-unlock"
                      @click="lockStock(scope.row)"></el-button>
                  </el-tooltip>
                  <el-tooltip v-if="searchForm.lock === 1 && WAREHOUSE_MODE == 2" class="item" effect="dark"
                    content="解锁商品" placement="top-start">
                    <el-button style="color: #f56c6c; padding-top: 0px" type="text" icon="el-icon-lock"
                      @click="unlockStock(scope.row)"></el-button>
                  </el-tooltip>
                  <el-button size="small" type="text" :disabled="!(scope.row.CAN_SPLIT > 0 && searchForm.lock === 0)"
                    @click="unpacking(scope.row)">
                    拆箱
                  </el-button>
                  <el-button size="small" type="text" @click="detail(scope.row)">查看</el-button>
                  <el-button size="small" type="text" @click="openLoss(scope.row)" v-if="searchForm.lock === 0">
                    报损
                  </el-button>
                  <el-button size="small" type="text" @click="openAdd(scope.row)" v-if="searchForm.lock === 0">
                    报溢
                  </el-button>
                  <el-button size="small" type="text" @click="addPage(scope.row)" v-if="searchForm.lock === 0">
                    合箱
                  </el-button>
                  <el-button size="small" type="text" icon="el-icon-view" @click="showMoving(scope.row)"
                    v-if="WAREHOUSE_MODE == 2 && searchForm.lock === 0">
                    移库
                  </el-button><br>
                  <el-button size="small" type="text" @click="showUploadBatch(scope.row)">
                    上传批次报告
                  </el-button><br>
                  <el-button size="small" type="text" @click="downloadBatch(scope.row)"
                    v-if="scope.row.BATCH_REPORT_ID !== 0">下载批次报告</el-button>
                  <el-button size="small" type="text" @click="updateProductionDate(scope.row)">
                    修改生产日期
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tabs>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
    <el-dialog title="导出库存" center :visible.sync="exportFormVisible" width="500px" :close-on-click-modal="false">
      <el-form :model="exportForm" ref="exportForm" size="small" :label-width="formLabelWidth">
        <el-form-item label="一级大类：">
          <el-select filterable v-model="exportForm.firstLevel" placeholder="请选择" clearable @change="changeFirst"
            style="width: 90%">
            <el-option v-for="item in firstList" :key="item.value" :label="item.NAME" :value="item.INNER_CODE">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级大类：">
          <el-select filterable v-model="exportForm.secondLevel" placeholder="请选择" clearable style="width: 90%">
            <el-option v-for="item in secondList" :key="item.value" :label="item.SECOND_NAME" :value="item.SECOND_CODE">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeExport">取 消</el-button>
        <el-button size="small" @click="submitExport">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="拆箱" center :visible.sync="unpackingVisible" width="600px">
      <el-form :model="addForm" ref="addForm" size="small" :label-width="formLabelWidth">
        <el-form-item label="产品名称：">
          <span>{{ addForm.PRODUCT_NAME }}</span>
        </el-form-item>
        <el-form-item label="库存数量：">
          <span>{{ addForm.PRODUCT_COUNT }}</span>
        </el-form-item>
        <el-form-item label="拆箱数量：">
          <el-input v-model="addForm.CXCOUNT" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" @click="submitUnpack">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 退货 -->
    <el-dialog title="退货信息" center :visible.sync="returnVisible" width="600px">
      <el-form :model="returnForm" ref="returnForm" size="small" :label-width="formLabelWidth">
        <el-form-item label="产品名称：">
          <span>{{ returnForm.PRODUCT_NAME }}</span>
        </el-form-item>
        <el-form-item label="库存数量：">
          <span>{{ returnForm.PRODUCT_COUNT }}</span>
        </el-form-item>
        <el-form-item label="退货数量：">
          <el-input v-model="returnForm.TCCOUNT" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="returnClose">取 消</el-button>
        <el-button size="small" @click="submitReturn">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 报损 -->
    <el-dialog title="库存报损" center :visible.sync="lossVisible" width="450px">
      <el-form :model="lossForm" ref="lossForm" size="small" :label-width="formLabelWidth">
        <el-form-item label="产品名称：">
          <span>{{ lossForm.PRODUCT_NAME }}</span>
        </el-form-item>
        <el-form-item label="库存数量：">
          <span>{{ lossForm.PRODUCT_COUNT }}</span>
        </el-form-item>
        <el-form-item label="报损：">
          <el-input v-model="lossForm.LOSS_COUNT" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="lossForm.REASON" style="width: 200px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeLoss">取 消</el-button>
        <el-button size="small" @click="submitLoss">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 报溢 -->
    <el-dialog title="库存报溢" center :visible.sync="addVisible" width="450px">
      <el-form :model="addForm" ref="addForm" size="small" :label-width="formLabelWidth">
        <el-form-item label="产品名称：">
          <span>{{ addForm.PRODUCT_NAME }}</span>
        </el-form-item>
        <el-form-item label="库存数量：">
          <span>{{ addForm.PRODUCT_COUNT }}</span>
        </el-form-item>
        <el-form-item label="报溢：">
          <el-input v-model="addForm.LOSS_COUNT" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="addForm.REASON" style="width: 200px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdd">取 消</el-button>
        <el-button size="small" @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 锁定商品 -->
    <el-dialog title="锁定商品" center :visible.sync="lockStockVisible" width="600px" :close-on-click-modal="false"
      @close="closeLockStock()">
      <!-- 单条锁定：三行文本 -->
      <el-form v-if="lockStockProducts.length === 1" size="small" :label-width="formLabelWidth">
        <el-form-item label="产品编码：">
          <span>{{ lockStockProducts[0].PRODUCT_CODE }}</span>
        </el-form-item>
        <el-form-item label="产品名称：">
          <span>{{ lockStockProducts[0].PRODUCT_NAME }}</span>
        </el-form-item>
        <el-form-item label="批次：">
          <span>{{ lockStockProducts[0].BATCH }}</span>
        </el-form-item>
      </el-form>
      <!-- 批量锁定：表格 -->
      <el-table v-else :data="lockStockProducts" stripe border max-height="250">
        <el-table-column prop="PRODUCT_CODE" label="产品编码" min-width="90"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="名称" min-width="130"></el-table-column>
        <el-table-column prop="BATCH" label="批次" min-width="100"></el-table-column>
      </el-table>
      <el-form size="small" :label-width="formLabelWidth" style="margin-top:10px">
        <el-form-item label="锁库原因：">
          <el-input type="textarea" :rows="3" maxlength="200" v-model="lockStockForm.LOCK_REASON"
            placeholder="请输入锁库原因（选填）"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeLockStock()">取 消</el-button>
        <el-button size="small" type="primary" @click="submitLockStock()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 拉取可合箱的产品 -->
    <el-dialog title="请选择需要合箱后的目标产品" center :visible.sync="addListVisible" width="600px">
      <el-table :data="addBoxList" stripe border>
        <el-table-column prop="NAME" label="名称"></el-table-column>
        <el-table-column prop="SUB_TYPE_COUNT" label="合箱比例"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="openAddBox(scope.row)">立即合箱</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 合箱 -->
    <el-dialog title="合箱" center :visible.sync="addBoxVisible" width="450px">
      <el-form :model="addBoxForm" ref="addBoxForm" size="small" :label-width="formLabelWidth">
        <el-form-item label="合箱数量：">
          <el-input v-model="addBoxForm.COUNT" style="width: 200px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addBoxVisible = false">取 消</el-button>
        <el-button size="small" @click="submitAddBox">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导出库存流水 -->
    <el-dialog title="导出操作流水" center :visible.sync="exportRecordVisible" width="550px">
      <el-form :model="exportRecordForm" ref="exportRecordForm" size="small" :label-width="formLabelWidth">
        <el-form-item label="日期范围：">
          <el-date-picker v-model="exportRecordForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="exportRecordVisible = false">取 消</el-button>
        <el-button size="small" @click="submitExportRecord">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 移动库存 -->
    <el-dialog title="移库" :visible.sync="movingFormVisible" width="500px" @close="closeMoving()"
      :close-on-click-modal="false">
      <el-form :model="movingForm" size="small" ref="movingForm" :rules="rules" :label-width="formLabelWidth">
        <el-form-item label="移库数量" prop="MOVING_NUM">
          <label slot="label">移&nbsp;库&nbsp;数&nbsp;量：</label>
          <el-input placeholder="移库数量" v-model="movingForm.MOVING_NUM" style="width: 80%"></el-input>
        </el-form-item>
        <!-- <el-form-item label="生产日期">
              <label slot="label">生&nbsp;产&nbsp;日&nbsp;期：</label>
              <el-date-picker value-format="yyyy-MM-dd" style="width: 80%" v-model="movingForm.PRODUCTION_DATE"
                type="date" placeholder="选择日期" :clearable="true"></el-date-picker>
            </el-form-item> -->
        <el-form-item label="目标库位">
          <label slot="label">目&nbsp;标&nbsp;库&nbsp;位：</label>
          <el-select placeholder="目标库位" v-model="movingForm.POSITION" clearable filterable
            :filter-method="positionFilter" style="width: 80%">
            <el-option v-for="item in positionList" :key="item.ID" :value="item.CODE" :label="item.CODE">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="closeMoving()">取 消</el-button>
        <el-button type="primary" @click="submitMoving('movingForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 上传批次报告 -->
    <el-dialog title="上传批次报告" center :visible.sync="uploadBatchFormVisible" width="400px" :close-on-click-modal="false">
      <el-form size="small" ref="uploadBatchForm" :model="uploadBatchForm" label-width="120px">
        <el-form-item label="送检单位" prop="SUBMIT_UNIT">
          <el-input v-model="uploadBatchForm.SUBMIT_UNIT" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="检测报告" prop="TEST_UNIT">
          <el-input v-model="uploadBatchForm.TEST_UNIT" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="批次报告">
          <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove"
            name="qualification" multiple :file-list="fileList" :data="上传批次报告参数">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
          </el-upload>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="关闭上传批次报告()">取 消</el-button>
        <el-button size="small" @click="uploadBatch()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改生产日期 -->
    <el-dialog title="修改生产日期" center :visible.sync="editDateFormVisible" width="500px" @close="cancelUpdate()"
      :close-on-click-modal="false">
      <el-form size="small" :model="editDateForm" ref="editDateForm">
        <el-form-item label="生产日期" prop="PRODUCTION_DATE" clearable="flase">
          <el-date-picker v-model="editDateForm.PRODUCTION_DATE" type="date" value-format="yyyy-MM-dd"
            :clearable="false" placeholder="请输入生产日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelUpdate()">取 消</el-button>
        <el-button type="primary" size="small" @click="submitUpdate(editDateForm)">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="导出滞销品" center :visible.sync="导出滞销品的模态框" width="500px" :close-on-click-modal="false">
      <el-form :model="导出滞销品的数据" ref="exportForm" size="small" :label-width="formLabelWidth">
        <el-form-item label="一级大类：">
          <el-select filterable v-model="导出滞销品的数据.一级大类" placeholder="请选择" clearable @change="changeFirst"
            style="width: 90%">
            <el-option v-for="item in firstList" :key="item.value" :label="item.NAME" :value="item.INNER_CODE">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级大类：">
          <el-select filterable v-model="导出滞销品的数据.二级大类" placeholder="请选择" clearable style="width: 90%">
            <el-option v-for="item in secondList" :key="item.value" :label="item.SECOND_NAME" :value="item.SECOND_CODE">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="清空导出滞销品表格()">取 消</el-button>
        <el-button size="small" @click="确认导出滞销品()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="报溢报损导出" center :visible.sync="报溢报损模态框" width="500px" :close-on-click-modal="false">
      <el-form :model="报溢报损表单" ref="exportForm" size="small" :label-width="formLabelWidth">
        <el-form-item label="日期范围">
          <el-date-picker type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
            v-model="报溢报损表单.报溢报损日期范围" value-format="yyyy-MM-dd" style="width:80%" :clearable="false">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="报溢报损模态框 = false">取消</el-button>
        <el-button size="small" @click="确认导出报溢报损()">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog title="批量退货" center :visible.sync="批量退货模态框" width="60%" :close-on-click-modal="false">
      <el-table :data="勾选的退货商品列表" stripe border style="width: 100%">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品" min-width="120"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位" min-width="70"></el-table-column>
        <el-table-column prop="BATCH" label="批次" min-width="200"></el-table-column>
        <el-table-column label="库位" v-if="WAREHOUSE_MODE == 2" prop="LOCATION_CODE"></el-table-column>
        <el-table-column label="退货数量" min-width="120">
          <template slot-scope="scope">
            <el-input v-model="scope.row.COUNT" @change="countChange(scope.row)"
              :placeholder="`最多可退${scope.row.PRODUCT_COUNT}`"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="退货原因">
          <template slot-scope="scope">
            <el-input v-model="scope.row.COMMENT"></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="批量退货模态框 = false">取消</el-button>
        <el-button size="small" v-loading="loading" @click="确认退货()">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog title="批量上传批次报告" center :visible.sync="批量上传报告模态框" width="400px" :close-on-click-modal="false">
      <el-form size="small" ref="批量上传批次报告表单" :model="批量上传批次报告表单" label-width="120px">
        <el-form-item label="送检单位" prop="SUBMIT_UNIT">
          <el-input v-model="批量上传批次报告表单.SUBMIT_UNIT" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="检测报告" prop="TEST_UNIT">
          <el-input v-model="批量上传批次报告表单.TEST_UNIT" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="批次报告">
          <el-upload class="upload-demo" action="/uploadFile" :on-success="handleSuccess" :on-remove="handleRemove"
            name="qualification" multiple :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过5M</div>
          </el-upload>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="关闭上传批次报告()">取 消</el-button>
        <el-button size="small" @click="确认批量上传批次报告()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="查看批次报告" center :visible.sync="查看批次报告模态框" width="400px" :close-on-click-modal="false">
      <el-form size="small" ref="查看批次报告模态框表单" :model="查看批次报告模态框表单" label-width="120px">
        <el-form-item label="送检单位" prop="SUBMIT_UNIT">
          <el-input v-model="查看批次报告模态框表单.SUBMIT_UNIT" disabled style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="检测报告" prop="TEST_UNIT">
          <el-input v-model="查看批次报告模态框表单.TEST_UNIT" disabled style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="批次报告">
          <el-button type="text" @click="下载批次报告()">下载报告</el-button>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="关闭上传批次报告()">取 消</el-button>
        <el-button size="small" @click="查看批次报告模态框 = false">确 定</el-button>
      </div>
    </el-dialog>
    <el-drawer :title="orderDetailObj.title" :visible.sync="orderDetailDrawer" size="80%">
      <el-descriptions :title="`订单ID：${orderDetailObj.info.ORDER_ID}`" :column="2" border>
        <el-descriptions-item label="供应商">{{ orderDetailObj.info.SUPPLIER_NAME }}</el-descriptions-item>
        <el-descriptions-item label="联系人">{{ orderDetailObj.info.CONTACT_NAME }}</el-descriptions-item>
        <el-descriptions-item label="公司">{{ orderDetailObj.info.GYS_NAME }}</el-descriptions-item>
        <el-descriptions-item label="订单编号">{{ orderDetailObj.info.ORDER_CODE }}</el-descriptions-item>
        <el-descriptions-item label="地址">{{ orderDetailObj.info.ADDRESS }}</el-descriptions-item>
        <el-descriptions-item label="送货日期">{{ orderDetailObj.info.SEND_DAY }}</el-descriptions-item>
      </el-descriptions>

      <el-table :data="orderDetailObj.detail" border stripe style="width: 100%; margin-top: 20px;"
        :row-style="setCorrespondingDetailStyle">
        <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
        <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
        <el-table-column label="名称" prop="SHORT_NAME" min-width="100"></el-table-column>
        <el-table-column label="品牌" prop="BRAND" min-width="100"></el-table-column>
        <el-table-column label="规格" prop="SPECIFICATION" min-width="100"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="GYS_PRICE" label="单价（元）"></el-table-column>
        <el-table-column prop="BEFORE_TAX_PRICE" label="不含税单价（元）"></el-table-column>
        <el-table-column prop="TAX_RATE" label="税率"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
        <el-table-column label="送货数量" prop="NEED_COUNT"></el-table-column>
        <el-table-column prop="REAL_COUNT" label="实收数量"></el-table-column>
        <el-table-column prop="TOTAL_FEE" label="总价（元）"></el-table-column>
        <el-table-column prop="PRODUCT_FEE_BEFORE_TAX" label="不含税总价（元）"></el-table-column>
        <el-table-column prop="PRODUCT_COMMENT" label="备注"></el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>
<script>
import {
  queryWarehouseFun, queryFirstFun, querySecondFun, exportWarehouseFun, unpackingFun, returnFun, lossFun,
  addBoxFun, addBoxListFun, addCountFun, exportRecordFun, sotckLock, sotckUnLock, queryPosition, exportExclStock,
  sotckNearExpire, exportWhouseMsg, movingStockPosition, stockUploadBatchReport, submitUpdate, historyReturnFun,
} from 'api/warehouseManager';
import { downloadBatchReport, historyOrderDetailFun } from 'api/shopOrderManage';
import { getActionFun } from 'api/login';
import { getClassFun, queryWQ } from '@/assets/api/skuManage';
import util from '@/assets/common/util';
import http from '@/assets/common/http';
import validation from '@/assets/common/validation';
import { showFullScreenLoading, tryHideFullScreenLoading } from '@/assets/plugin/loading/loading';
import { 判断日期范围是否超过限制 } from '@/assets/common/date';

export default {
  data () {
    const validateunbox = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入数量'));
      }
      value = Number(value);
      setTimeout(() => {
        if (Number.isInteger(value)) {
          if (value < 0) {
            callback(new Error('数量不能小于0'));
          } else if (value > this.unboxingForm.PRODUCT_COUNT) {
            callback(new Error('数量不能大于库存'));
          } else {
            callback();
          }
        } else {
          callback(new Error('请输入整数'));
        }
      }, 100);
    };
    return {
      上传批次报告参数: {
        remainName: 1,
      },
      PAGE_ID: '10502', // 页面ID 一旦规定不要轻易改动
      fun_dic: {
        1050201: 0, 1050202: 0,
      },
      勾选的退货商品列表: [],
      批量退货模态框: false,
      exportFormVisible: false,
      exportForm: {},
      firstList: [],
      secondList: [],
      报溢报损表单: {},
      returnVisible: false,
      showStatus: 0,
      returnForm: {},
      count: 0,
      showAll: true,
      searchForm: {
        name: '',
        code: '',
        lock: 0,
      },
      firstTypeList: [],
      TAB_CODE: '',
      total_price: 0,
      tableData: [],
      totalCount: 0,
      pageSize: 20,
      currentPage: 1,
      addForm: {},
      formLabelWidth: '120px',
      unpackingVisible: false,
      lossForm: {},
      lossVisible: false,
      lockStockVisible: false,
      lockStockForm: { LOCK_REASON: '' },
      lockStockIds: [],
      lockStockProducts: [],
      addBoxVisible: false,
      addBoxForm: {},
      addListVisible: false,
      addBoxList: [],
      addVisible: false,
      报溢报损模态框: false,
      pickerOptions: [],
      exportRecordVisible: false,
      exportRecordForm: {
        DAY_INTERVAL: [],
      },
      column_order: null,
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
      productionStatus: [
        {
          label: '未锁定',
          id: 0,
        },
        {
          label: '锁定',
          id: 1,
        },
      ],
      allPositionList: [],
      positionList: [],
      near: '',
      movingFormVisible: false,
      movingForm: {
        POSITION: '',
        MOVING_NUM: 0,
        PRODUCTION_DATE: '',
      },
      editDateForm: {},
      导出滞销品的数据: {
        一级大类: '',
        二级大类: '',
      },
      editDateFormVisible: false,
      导出滞销品的模态框: false,
      rules: {
        DEVANNING_NUM: [{ validator: validateunbox, trigger: 'change' }],
      },
      QGP_TIME_TYPE: ['', '年', '季', '个月', '天', '小时'],
      catalogList: [],
      fromWelcome: sessionStorage.getItem('fromWelcome') ? sessionStorage.getItem('fromWelcome') : 0,
      uploadBatchFormVisible: false,
      uploadBatchForm: {},
      fileList: [],
      productArray: [],
      showTemperatureZone: false,
      WZ_list: [],
      loading: false,
      批量上传报告模态框: false,
      批量上传批次报告表单: {},
      查看批次报告模态框: false,
      查看批次报告模态框表单: {},
      orderDetailDrawer: false,
      orderDetailObj: {
        info: {},
        detail: [],
        title: '',
      },
    };
  },
  created () {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    this.queryBeforeFun();
  },
  mounted () {
    if (this.SAVE_STOCKLIST) {
      this.searchForm = this.SAVE_STOCKLIST.CONDITION;
      this.currentPage = this.SAVE_STOCKLIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
      this.searchForm.lock = 0;
    }
    this.showStatus = 0;
    this.clickfirstType();
    this.queryPostionList();
    this.queryCatalog();
    this.queryWZ();
    if (this.fromWelcome == 1) {
      this.handleSearchNear();
      sessionStorage.removeItem('fromWelcome');
    } else {
      this.queryStockList();
    }
  },
  computed: {
    // 上一次的搜索结果和条件
    SAVE_STOCKLIST () {
      return this.$store.state.SAVE_STOCKLIST;
    },
  },
  methods: {
    确认批量上传批次报告 () {
      const promises = [];
      const errList = [];
      let 是否出现问题 = false;
      for (const item of this.勾选的退货商品列表) {
        const params = {
          BATCH: item.BATCH,
          PRODUCT_CODE: item.PRODUCT_CODE,
          FILE_URL: this.fileList.map((item2) => item2.response.file_name),
          SUBMIT_UNIT: this.批量上传批次报告表单.SUBMIT_UNIT,
          TEST_UNIT: this.批量上传批次报告表单.TEST_UNIT,
        };
        promises.push(stockUploadBatchReport(params).then(() => {
          // eslint-disable-next-line no-loop-func
        }).catch((error) => {
          是否出现问题 = true;
          errList.push(error);
        }));
      }
      Promise.all(promises).then(() => {
        if (是否出现问题) {
          this.$message.show({ text: errList, type: 'error' });
          return false;
        }
        this.queryStockList();
        this.批量上传批次报告表单 = {};
        this.批量上传报告模态框 = false;
        this.$message.show({ text: '全部上传成功', type: 'success' });
        this.fileList = [];
      });
    },
    批量上传批次报告 () {
      if (this.勾选的退货商品列表.length == 0) {
        this.$message.show({ text: '请勾选需要批量上传的产品', type: 'warning' });
        return false;
      }
      this.批量上传报告模态框 = true;
    },
    queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    确认退货 () {
      const groupedItems = this.勾选的退货商品列表.reduce((acc, item) => {
        if (!acc[item.ORDER_ID]) {
          acc[item.ORDER_ID] = {
            ID: item.ORDER_ID,
            submitArr: [],
          };
        }
        acc[item.ORDER_ID].submitArr.push({
          BATCH: item.BATCH,
          PRODUCT_CODE: item.PRODUCT_CODE,
          PRODUCT_COUNT: item.COUNT,
          RETURN_REASON: item.COMMENT || '',
          LOCATION_CODE: item.LOCATION_CODE || 0,
          PRODUCTION_DATE: item.PRODUCTION_DATE,
          AFTER_TYPE_UNIT: item.TYPE_UNIT,
          DETAIL_ID: item.DETAIL_ID,
        });
        return acc;
      }, {});
      const groupedItemsArray = Object.values(groupedItems);
      const flag = groupedItemsArray.every((groupItem) => groupItem.submitArr.every(({ AFTER_TYPE_UNIT, PRODUCT_COUNT }) => {
        if (util.JudgmentUnit(AFTER_TYPE_UNIT)) {
          if (validation.数量两位小数正数验证(PRODUCT_COUNT)) {
            return true;
          }
        } else {
          if (validation.数量整数正数验证(PRODUCT_COUNT)) {
            return true;
          }
        }
        return false; // 如果之前的条件都不满足，则返回false
      }));
      const lacationFlag = groupedItemsArray.every((groupItem) => groupItem.submitArr.find((item) => {
        if (!item.LOCATION_CODE) {
          return true;
        }
      }));
      if (!flag) {
        this.$message.show({ text: '请输入正确的退货数量', type: 'warning' });
        document.body.style.cursor = 'default';
        return false;
      }
      if (this.WAREHOUSE_MODE == 2 && lacationFlag) {
        this.$message.show({ text: '请选择库位', type: 'warning' });
        document.body.style.cursor = 'default';
        return false;
      }

      let 是否出现问题 = false;
      const errList = [];
      showFullScreenLoading();
      const 按顺序执行退货 = (顺序链, 当前执行的顺序) => 顺序链.then(() => 当前执行的顺序().catch((error) => {
        是否出现问题 = true;
        errList.push(error);
      }));
      const 顺序链 = groupedItemsArray.reduce((顺序链2, item) => {
        const params = {
          ORDER_ID: item.ID,
          DETAILS: item.submitArr,
          GYS_ID: Number(sessionStorage.getItem('tcId')),
          RECORD_ID: Number(sessionStorage.getItem('DELIVER_ID')),
          WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
        };
        return 按顺序执行退货(顺序链2, () => historyReturnFun(params));
      }, Promise.resolve());
      顺序链.then(() => {
        tryHideFullScreenLoading();
        if (是否出现问题) {
          this.$message.show({ text: errList, type: 'error' });
          return false;
        }
        this.$message.show({ text: '所有退货操作已完成', type: 'success' });
        this.批量退货模态框 = false;
        this.queryStockList();
      }).catch((error) => {
      });
    },
    countChange (row) {
      if (!validation.数量两位小数正数验证(row.COUNT)) {
        this.$message.show({ text: '请输入正确的退货数量', type: 'warning' });
        return false;
      }
      if (!this.$util.JudgmentUnit(row.AFTER_TYPE_UNIT) && !validation.数量整数正数验证(row.COUNT)) {
        this.$message.show({ text: '请输入正整数的退货数量', type: 'warning' });
        return false;
      }
      if (Number(row.COUNT) > Number(row.PRODUCT_COUNT)) {
        this.$message.show({ text: '总退货数量不能大于入库数量', type: 'warning' });
        return false;
      }
    },
    确认导出报溢报损 () {
      if (!(this.报溢报损表单.报溢报损日期范围 && this.报溢报损表单.报溢报损日期范围[0])) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
      }
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 102,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        GYS_ID: sessionStorage.getItem('tcId'),
        START_DAY: this.报溢报损表单.报溢报损日期范围[0],
        END_DAY: this.报溢报损表单.报溢报损日期范围[1],
      };
      http.post(params).then((result) => {
        if (result[0].FILE_PATH) {
          window.location.href = util.getURLLocalHost(result[0].FILE_PATH);
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    批量退货 () {
      if (this.勾选的退货商品列表.length == 0) {
        this.$message.show({ text: '请勾选需要退货的商品', type: 'warning' });
        return false;
      }
      let 是否有没有找到ORDER_ID的勾选项 = false;
      this.勾选的退货商品列表.forEach((item) => {
        if (item.ORDER_ID === null || item.ORDER_ID === undefined || item.ORDER_ID === 0 || item.DETAIL_ID === null || item.DETAIL_ID === undefined || item.DETAIL_ID === 0) {
          this.$message.show({ text: `${item.PRODUCT_NAME + item.BATCH}未关联到订单,请查询勾选`, type: 'warning' });
          是否有没有找到ORDER_ID的勾选项 = true;
        }
      });
      if (是否有没有找到ORDER_ID的勾选项) {
        return false;
      }
      this.批量退货模态框 = true;
    },
    打开报溢报损模态框 () {
      this.报溢报损模态框 = true;
    },
    // 勾选产品
    handleProductSelectionChange (val) {
      this.productArray = val.map(({ ID }) => ID);
      this.勾选的退货商品列表 = val;
    },
    bathLockProduct () {
      this.lockStockIds = this.productArray;
      this.lockStockProducts = this.勾选的退货商品列表.map((item) => ({
        PRODUCT_CODE: item.PRODUCT_CODE,
        PRODUCT_NAME: item.PRODUCT_NAME,
        BATCH: item.BATCH,
      }));
      this.lockStockForm.LOCK_REASON = '';
      this.lockStockVisible = true;
    },
    bathUnLockProduct () {
      const params = {
        DETAIL_ID: this.productArray,
      };
      sotckUnLock(params).then((result) => {
        this.$message.show({ text: '解锁成功', type: 'success' });
        this.handleSearch();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    date_sort (column) {
      this.column_order = column.order;
      if ((this.searchForm.name && this.searchForm.name != '') || (this.searchForm.code && this.searchForm.code != '')) {
        this.queryStockList();
      } else {
        this.getStorageList();
      }
    },
    // ---------------------------------------------导出
    exportOrder () {
      this.exportFormVisible = true;
    },
    submitExport () {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            FIRST_LEVEL_CATALOG: this.exportForm.firstLevel,
            SECOND_LEVEL_CATALOG: this.exportForm.secondLevel,
          };
          exportWarehouseFun(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            this.exportFormVisible = false;
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    changeFirst (e) {
      this.querySecondLevel(e);
    },
    querySecondLevel (e) {
      const params = {
        FIRST_LEVEL_CATALOG: e,
      };
      querySecondFun(params).then((result) => {
        this.secondList = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    closeExport () {
      this.exportFormVisible = false;
      this.exportForm = {};
    },
    // ---------------------------出库
    returnStock (row) {
      this.returnVisible = true;
      this.returnForm = row;
    },
    submitReturn () {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
          if (!reg.test(Number(this.returnForm.TCCOUNT))) {
            this.$message.show({ text: '请输入退货数量', type: 'warning' });
            document.body.style.cursor = 'default';
            return false;
          }
          const params = {
            BATCH: this.returnForm.BATCH,
            PRODUCT_CODE: this.returnForm.PRODUCT_CODE,
            COUNT: Number(this.returnForm.TCCOUNT),
            WAREHOUSE_COUNT: Number(this.returnForm.PRODUCT_COUNT),
            PRICE: Number(this.returnForm.PRODUCT_PRICE),
          };
          returnFun(params).then((result) => {
            this.$message.show({ text: '操作成功', type: 'success' });
            this.returnVisible = false;
            this.getStorageList();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    returnClose () {
      this.returnVisible = false;
    },
    // ---------------------------显示隐藏库存为零
    showBlock () {
      if (this.showStatus !== 1) {
        this.showStatus = 1;
        this.getStorageList();
      } else {
        this.showStatus = 0;
        this.getStorageList();
      }
    },
    // ---------------------------查看
    detail (row) {
      this.$router.push({ path: '/stockListDetail/detail' });
      sessionStorage.setItem('BATCH', row.BATCH);
      sessionStorage.setItem('PRODUCT_CODE', row.PRODUCT_CODE);
      sessionStorage.setItem('PRODUCT_NAME', row.PRODUCT_NAME);
    },
    // ----------------------------allSubmit
    unpacking (row) {
      this.addForm = row;
      this.unpackingVisible = true;
    },
    close () {
      this.unpackingVisible = false;
      this.getStorageList();
    },
    submitUnpack () {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          // 正则：正数
          const reg1 = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
          // 正则：正整数
          const reg2 = /^\d+(\.0+)?$/;
          if (util.JudgmentUnit(this.addForm.TYPE_UNIT)) {
            if (!reg1.test(this.addForm.CXCOUNT)) {
              document.body.style.cursor = 'default';
              this.$message.show({ text: '请输入正确的拆箱数量', type: 'warning' });
              return false;
            }
          } else if (!reg2.test(this.addForm.CXCOUNT)) {
            document.body.style.cursor = 'default';
            this.$message.show({ text: '请输入正确的拆箱数量', type: 'warning' });
            return false;
          }
          const params = {
            BATCH: this.addForm.BATCH,
            PRODUCT_CODE: this.addForm.PRODUCT_CODE,
            PRODUCT_NUMBER: Number(this.addForm.CXCOUNT),
            LOCATION_ID: this.addForm.LOCATION_ID,
          };
          unpackingFun(params).then((result) => {
            this.$message.show({ text: '拆箱成功', type: 'success' });
            this.unpackingVisible = false;
            this.getStorageList();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    handleCurrentChange (e) {
      this.currentPage = e;
      if (this.near == 1) {
        this.handleSearchNear();
      } else if (this.searchForm.name || this.searchForm.code || this.searchForm.CATALOG_ID || this.searchForm.location) {
        this.queryStockList();
      } else {
        this.getStorageList();
      }
    },
    // -----------------------------筛选功能
    handleSearch () {
      this.currentPage = 1;
      this.queryStockList();
    },
    queryStockList () {
      this.near = 0;
      if (this.showStatus && !(this.searchForm.name.trim() || this.searchForm.code.trim())) {
        this.$message.show({ text: '查看零库存，必须筛选商品', type: 'warning' });
        return;
      }
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SHOW: this.showStatus,
        FLAG: this.searchForm.lock,
        WAREHOUSE_MODE: this.WAREHOUSE_MODE,
      };
      if (this.searchForm.code) {
        params.PRODUCT_CODE = this.searchForm.code;
      }
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      if (this.searchForm.location) {
        params.LOCATION_CODE = this.searchForm.location;
      }
      if (this.searchForm.CATALOG_ID) {
        params.FIRST_CATALOG_CODE = this.searchForm.CATALOG_ID;
      }
      if (this.searchForm.WZ_TYPE_ID) {
        params.WZ_TYPE_ID = this.searchForm.WZ_TYPE_ID;
      }
      switch (this.column_order) {
        case 'ascending':
          params.TIME_FLAG = 1;
          break;
        case 'descending':
          params.TIME_FLAG = 2;
          break;
        default:
        // do nothing
      }
      this.loading = true;
      queryWarehouseFun(params).then((result) => {
        if (result.length !== 0) {
          this.totalCount = result[0].TOTAL_COUNT;
          this.tableData = result[0].OP_ROLE.map((item) => ({
            ...item,
            BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2),
            CXCOUNT: item.CXCount,
          }));
          this.total_price = result[0].TOTAL_WORTH;
          this.showTemperatureZone = Boolean(result[0].IS_STOCK_LIST_SHOW_TEMPERATURE_ZONE);
        } else {
          this.total_price = 0;
          this.tableData = [];
          this.totalCount = 0;
          this.showTemperatureZone = false;
        }
        // 将搜索结果和条件存储到vuex中
        this.$store.dispatch('SET_SAVE_STOCKLIST', {
          CONDITION: this.searchForm,
          CURRENT_PAGE: this.currentPage,
        });
        this.loading = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading = false;
      });
    },
    handleSearchNear () {
      this.near = 1;
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SHOW: this.showStatus,
        TYPE: this.searchForm.lock,
        FLAG: this.searchForm.lock,
      };
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      if (this.searchForm.code) {
        params.PRODUCT_CODE = this.searchForm.code;
      }
      if (this.searchForm.WZ_TYPE_ID) {
        params.WZ_TYPE_ID = this.searchForm.WZ_TYPE_ID;
      }
      this.loading = true;
      sotckNearExpire(params).then((result) => {
        if (result.length !== 0) {
          this.totalCount = result[0].TOTAL_COUNT;
          this.tableData = result[0].OP_ROLE.map((item) => ({ ...item, BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2) }))
            .map((item, index) => Object.assign(item, { CXCOUNT: item.CXCount }));
          this.total_price = result[0].TOTAL_WORTH;
          this.showTemperatureZone = Boolean(result[0].IS_STOCK_LIST_SHOW_TEMPERATURE_ZONE);
        } else {
          this.total_price = 0;
          this.tableData = [];
          this.totalCount = 0;
          this.showTemperatureZone = false;
        }
        // 将搜索结果和条件存储到vuex中
        this.$store.dispatch('SET_SAVE_STOCKLIST', {
          CONDITION: this.searchForm,
          CURRENT_PAGE: this.currentPage,
        });
        if ((this.currentPage - 1) * this.pageSize > this.totalCount) {
          this.currentPage = 1;
          this.handleSearch();
        }
        this.loading = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loading = false;
      });
    },
    // ----------------------------------------获取全部一级大类
    clickfirstType () {
      const params = {
        WAREHOUSE_MODE: this.WAREHOUSE_MODE,
      };
      queryFirstFun(params).then((result) => {
        if (result[0]) {
          this.firstTypeList = result;
          this.firstList = result;
          this.TAB_CODE = result[0].INNER_CODE;
        } else {
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ------------------------------------------点击一级大类获取一级大类内容
    getStorageList () {
      this.near = 0;
      if (this.showStatus && !(this.searchForm.name.trim() || this.searchForm.code.trim())) {
        this.$message.show({ text: '查看零库存，必须筛选商品', type: 'warning' });
        return;
      }
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SHOW: this.showStatus,
        WAREHOUSE_MODE: this.WAREHOUSE_MODE,
        FLAG: this.searchForm.lock,
      };
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      if (this.searchForm.code) {
        params.PRODUCT_CODE = this.searchForm.code;
      }
      if (this.TAB_CODE > 99 || this.TAB_CODE == -1) {
        if (this.TAB_CODE) {
          params.FIRST_CATALOG_CODE = this.TAB_CODE;
        }
      }
      switch (this.column_order) {
        case 'ascending':
          params.TIME_FLAG = 1;
          break;
        case 'descending':
          params.TIME_FLAG = 2;
          break;
        default:
      }
      if (this.searchForm.location) {
        params.LOCATION_CODE = this.searchForm.location;
      }
      queryWarehouseFun(params).then((result) => {
        this.totalCount = result[0].TOTAL_COUNT;
        this.tableData = result[0].OP_ROLE.map((item) => ({ ...item, BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2) }))
          .map((item, index) => Object.assign(item, { CXCOUNT: item.CXCount }));
        if (result[0].TOTAL_WORTH !== '') {
          this.total_price = result[0].TOTAL_WORTH;
        } else {
          this.total_price = 0;
        }
        // 将搜索结果和条件存储到vuex中
        this.$store.dispatch('SET_SAVE_STOCKLIST', {
          CONDITION: this.searchForm,
          CURRENT_PAGE: this.currentPage,
        });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    getTabValue (tab, event) {
      this.TAB_CODE = tab.$attrs.code;
      this.currentPage = 1;
      this.searchForm = { lock: 0 };
      this.getStorageList();
    },
    openLoss (row) {
      this.lossVisible = true;
      this.lossForm = row;
    },
    submitLoss () {
      let tag = true;
      const reg_int = /^\d+$/;
      const reg_float = /^(\+)?\d+(\.\d+)?$/;
      if (this.lossForm.LOSS_COUNT) {
        if (util.JudgmentUnit(this.lossForm.TYPE_UNIT)) {
          if (!reg_float.test(this.lossForm.LOSS_COUNT)) tag = false;
        } else {
          if (!reg_int.test(this.lossForm.LOSS_COUNT)) tag = false;
        }
      } else {
        this.$message.show({ text: '请输入报损数量', type: 'warning' });
        return false;
      }
      if (tag) {
        const params = {
          BATCH: this.lossForm.BATCH,
          PRODUCT_CODE: this.lossForm.PRODUCT_CODE,
          PRODUCT_COUNT: Number(this.lossForm.LOSS_COUNT),
          REASON: this.lossForm.REASON,
          LOCATION_ID: this.lossForm.LOCATION_ID,
        };
        lossFun(params).then((result) => {
          this.$message.show({ text: '报损成功', type: 'success' });
          this.lossVisible = false;
          // this.getStorageList();
          if (this.searchForm.name || this.searchForm.code || this.searchForm.CATALOG_ID || this.searchForm.location) {
            this.queryStockList();
          } else {
            this.getStorageList();
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        this.$message.show({ text: '请输入正确的报损数量', type: 'warning' });
      }
    },
    closeLoss () {
      this.lossVisible = false;
    },
    addPage (row) {
      const params = {
        PRODUCT_CODE: row.PRODUCT_CODE,
      };
      addBoxListFun(params).then((result) => {
        if (result.length !== 0) {
          this.addBoxList = result;
          this.addListVisible = true;
        } else {
          this.$message.show({ text: '暂无配置信息', type: 'error' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
      this.addBoxForm = row;
    },
    openAddBox (row) {
      this.addBoxVisible = true;
      this.addBoxForm.ABOVE_PRODUCT_CODE = row.INNER_CODE;
    },
    submitAddBox () {
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(this.addBoxForm.COUNT)) {
        this.$message.show({ text: '请输入正数的合箱数量', type: 'warning' });
        return false;
      }
      const params = {
        BATCH: this.addBoxForm.BATCH,
        PRODUCT_CODE: this.addBoxForm.PRODUCT_CODE,
        PRODUCT_NUMBER: Number(this.addBoxForm.COUNT),
        ABOVE_PRODUCT_CODE: this.addBoxForm.ABOVE_PRODUCT_CODE,
        LOCATION_ID: this.addBoxForm.LOCATION_ID,
      };
      addBoxFun(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.addListVisible = false;
        this.addBoxVisible = false;
        this.getStorageList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openAdd (row) {
      this.addVisible = true;
      this.addForm = row;
    },
    submitAdd () {
      // 正则：正数
      const reg1 = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      // 正则：正整数
      const reg2 = /^\d+(\.0+)?$/;
      if (util.JudgmentUnit(this.addForm.TYPE_UNIT)) {
        if (!reg1.test(this.addForm.LOSS_COUNT)) {
          document.body.style.cursor = 'default';
          this.$message.show({ text: '请输入正确的报溢数量', type: 'warning' });
          return false;
        }
      } else if (!reg2.test(this.addForm.LOSS_COUNT)) {
        document.body.style.cursor = 'default';
        this.$message.show({ text: '请输入正确的报溢数量', type: 'warning' });
        return false;
      }
      const params = {
        BATCH: this.addForm.BATCH,
        PRODUCT_CODE: this.addForm.PRODUCT_CODE,
        PRODUCT_COUNT: Number(this.addForm.LOSS_COUNT),
        REASON: this.addForm.REASON,
        LOCATION_ID: this.addForm.LOCATION_ID,
      };
      addCountFun(params).then((result) => {
        this.$message.show({ text: '报溢成功', type: 'success' });
        this.addVisible = false;
        this.getStorageList();
        document.body.style.cursor = 'default';
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        document.body.style.cursor = 'default';
      });
    },
    closeAdd () {
      this.addVisible = false;
    },
    exportRecord () {
      this.exportRecordVisible = true;
    },
    submitExportRecord () {
      const params = {
        WAREHOUSE_MODE: this.WAREHOUSE_MODE,
      };
      if (this.exportRecordForm.DAY_INTERVAL && this.exportRecordForm.DAY_INTERVAL.length) {
        if (判断日期范围是否超过限制(...this.exportRecordForm.DAY_INTERVAL)) {
          this.$message.show({ text: '选择的日期范围请不要大于一个月', type: 'warning' });
          return;
        }
        params.START_DAY = this.exportRecordForm.DAY_INTERVAL[0];
        params.END_DAY = this.exportRecordForm.DAY_INTERVAL[1];
      } else {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      exportRecordFun(params).then((res) => {
        window.open(this.$util.getURLLocalHost(res[0].FILE_PATH));
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    lockStock (row) {
      this.lockStockIds = [row.ID];
      this.lockStockProducts = [{
        PRODUCT_CODE: row.PRODUCT_CODE,
        PRODUCT_NAME: row.PRODUCT_NAME,
        BATCH: row.BATCH,
      }];
      this.lockStockForm.LOCK_REASON = '';
      this.lockStockVisible = true;
    },
    submitLockStock () {
      const params = {
        DETAIL_ID: this.lockStockIds,
        LOCK_REASON: this.lockStockForm.LOCK_REASON,
      };
      sotckLock(params).then((result) => {
        this.$message.show({ text: '锁定成功', type: 'success' });
        this.closeLockStock();
        this.handleSearch();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    closeLockStock () {
      this.lockStockVisible = false;
      this.lockStockForm.LOCK_REASON = '';
      this.lockStockIds = [];
      this.lockStockProducts = [];
    },
    unlockStock (row) {
      const params = {
        DETAIL_ID: [row.ID],
      };
      sotckUnLock(params).then((result) => {
        this.$message.show({ text: '解锁成功', type: 'success' });
        this.handleSearch();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryPostionList () {
      // if (this.POSITION_CONDITION.POSITIONLIST != null) {
      //   this.positionListAll = this.POSITION_CONDITION.POSITIONLIST;
      //   return;
      // }
      const params = {
        STATUS: 1,
      };
      if (this.movingForm.LOCATION_ID) {
        params.LOCATION_ID = this.movingForm.LOCATION_ID;
      }
      queryPosition(params).then((result) => {
        this.allPositionList = Object.freeze(result);
        this.positionList = this.allPositionList;
        // 将库位信息存储到vuex中
        this.$store.dispatch('SET_POSITION_CONDITION', {
          POSITIONLIST: result,
        });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    positionFilter (query = '') {
      const arr = this.allPositionList.filter((item) => item.CODE.includes(query));
      if (arr.length > 50) {
        this.positionList = arr.slice(0, 50);
      } else {
        this.positionList = arr;
      }
    },
    // 导出产品库位表
    exportStockExcl () {
      exportExclStock()
        .then((result) => {
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // 导出临保
    exportWhouse () {
      const params = {};
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      if (this.searchForm.code) {
        params.PRODUCT_CODE = this.searchForm.code;
      }
      exportWhouseMsg(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        this.$message.show({ text: '导出成功', type: 'success' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 移库
    showMoving (row) {
      this.movingForm = row;
      this.queryPostionList();
      this.movingFormVisible = true;
    },
    closeMoving () {
      this.movingFormVisible = false;
      this.movingForm = {
        PRODUCT_COUNT: '',
        MOVING_NUM: '',
        POSITION: '',
        PRODUCTION_DATE: '',
        LOCATION_ID: '',
      };
      this.queryPostionList();
    },
    submitMoving (movingForm) {
      const params = {
        MOVE_COUNT: this.movingForm.MOVING_NUM,
        DETAIL_ID: this.movingForm.ID,
        TARGET_LOCATION: this.movingForm.POSITION,
        PRODUCTION_DATE: this.movingForm.PRODUCTION_DATE,
      };
      this.$refs[movingForm].validate((valid) => {
        if (valid) {
          movingStockPosition(params).then((result) => {
            this.$message.show({ text: '移库成功', type: 'success' });
            this.closeMoving();
            this.handleSearch();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
        }
      });
    },
    下载批次报告 () {
      window.open(this.$util.getURLLocalHost(this.查看批次报告模态框表单.FILE_PATH), 'file');
    },
    downloadBatch (row) {
      const params = {
        BATCH_REPORT_ID: row.BATCH_REPORT_ID,
      };
      downloadBatchReport(params).then((result) => {
        this.查看批次报告模态框表单 = { ...result[0] };
        this.查看批次报告模态框 = true;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    gotoHistoricalInventory () {
      this.$router.push({ path: '/historicalInventory' });
    },
    queryCatalog () {
      const params = {};
      getClassFun(params).then((result) => {
        if (result.length !== 0) {
          this.catalogList = result;
        } else {
          this.catalogList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 上传批次报告
    showUploadBatch (row) {
      this.uploadBatchFormVisible = true;
      this.uploadBatchForm = { ...row };
    },
    handleSuccess (response, file, fileList) {
      this.fileList = fileList;
    },
    handleRemove (file, fileList) {
      this.fileList = fileList;
      this.file_name = '';
    },
    关闭上传批次报告 () {
      this.uploadBatchFormVisible = false;
      this.批量上传报告模态框 = false;
      this.查看批次报告模态框 = false;
      this.fileList = [];
    },
    uploadBatch () {
      const params = {
        BATCH: this.uploadBatchForm.BATCH,
        PRODUCT_CODE: this.uploadBatchForm.PRODUCT_CODE,
        FILE_URL: this.fileList.map((item) => item.response.file_name),
        SUBMIT_UNIT: this.uploadBatchForm.SUBMIT_UNIT,
        TEST_UNIT: this.uploadBatchForm.TEST_UNIT,
      };

      stockUploadBatchReport(params).then((result) => {
        this.$message.show({ text: '上传批次报告成功', type: 'success' });
        this.关闭上传批次报告();
        this.uploadBatchForm = {};
        this.file_name = '';
        this.fileList = [];
        this.getStorageList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    gotoSafetyStockWarning () {
      this.$router.push({ path: '/safetyStockWarning' });
    },
    导出滞销品 () {
      this.导出滞销品的模态框 = true;
    },
    清空导出滞销品表格 () {
      this.导出滞销品的模态框 = false;
      this.导出滞销品的数据 = {};
    },
    确认导出滞销品 () {
      if (!this.导出滞销品的数据.一级大类) {
        this.$message.show({ text: '请选择一级大类', type: 'warning' });
        return false;
      }
      if (!this.导出滞销品的数据.二级大类) {
        this.$message.show({ text: '请选择二级大类', type: 'warning' });
        return false;
      }
      const params = {
        FIRST_LEVEL_CATALOG: this.导出滞销品的数据.一级大类,
        SECOND_LEVEL_CATALOG: this.导出滞销品的数据.二级大类,
        DEAD: 1,
      };
      exportWarehouseFun(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        this.清空导出滞销品表格();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    updateProductionDate (row) {
      this.editDateFormVisible = true;
      this.editDateForm = { ...row };
    },
    // 修改生产日期
    cancelUpdate (row) {
      this.editDateFormVisible = false;
    },

    // 提交修改订单日期
    submitUpdate () {
      if (!this.editDateForm.PRODUCTION_DATE) {
        this.$message.show({ text: '请选择修改时间', type: 'warning' });
        return;
      }
      const params = {
        GYS_WAREHOUSE_DETAIL_ID: this.editDateForm.ID,
        PRODUCTION_DATE: this.editDateForm.PRODUCTION_DATE,
      };
      submitUpdate(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.editDateFormVisible = false;
        this.queryStockList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 拉取温区
    queryWZ () {
      queryWQ().then((result) => {
        this.WZ_list = result;
      }).catch((error) => {
      });
    },
    showOrderDetail ({ ORDER_ID: ID, BATCH, PRODUCT_CODE }) {
      const params = {
        ID,
      };
      historyOrderDetailFun(params).then((result) => {
        if (result && result[0]) {
          const info = {
            ...result[0].title[0], CONTACT_NAME: result[0].bottom[0].CONTACT_NAME, ORDER_ID: ID, PRODUCT_CODE,
          };
          const detail = result[0].list.map((item) => ({
            ...item,
            TOTAL_FEE: item.TOTAL_FEE.toFixed(2),
            BEFORE_TAX_PRICE: Number(item.BEFORE_TAX_PRICE).toFixed(2),
            NEW_BEFORE_TAX_PRICE: Number((item.REAL_PRICE / (1 + item.TAX_RATE / 100)).toFixed(10)),
          }));
          const title = `批次：${BATCH}的订单信息`;
          this.orderDetailObj = { info, detail, title };
          this.orderDetailDrawer = true;
        } else {
          this.$message.show({ text: '未找到订单信息', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    setCorrespondingDetailStyle ({ row }) {
      return row.PRODUCT_CODE == this.orderDetailObj.info.PRODUCT_CODE ? { color: 'red' } : {};
    },
  },
};
</script>

<style scoped>
.el-drawer__wrapper /deep/ .el-drawer__body {
  padding: 3px 30px;
  overflow-y: auto;
  height: calc(100vh - 140px);
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/stockList.vue